// extracted by mini-css-extract-plugin
export default {"title":"TableSectionTitle_title__MEkjn"};